import { SPACE_NAME } from './clients';
import { flushByTag } from '@tuic/cache';

export const createSpaceCacheTag = (space: SPACE_NAME) => {
  return `s:${space}`;
};

export const createContentTypeCacheTag = (contentType: string) => {
  return `ct:${contentType}`;
};

export const flushByContentType = async (contentType: string | string[]) => {
  if (Array.isArray(contentType)) {
    await Promise.all(contentType.map(type => flushByContentType(type)));

    return;
  }

  let tag = createContentTypeCacheTag(contentType);

  await flushByTag(tag);
};

export const flushBySpace = async (space: SPACE_NAME | SPACE_NAME[]) => {
  if (Array.isArray(space)) {
    await Promise.all(space.map(spaceName => flushBySpace(spaceName)));

    return;
  }

  let tag = createSpaceCacheTag(space);

  await flushByTag(tag);
};
